import { render } from "./OrganicRankingTimeSeries.vue?vue&type=template&id=3b9d04b7"
import script from "./OrganicRankingTimeSeries.vue?vue&type=script&lang=js"
export * from "./OrganicRankingTimeSeries.vue?vue&type=script&lang=js"

import "./OrganicRankingTimeSeries.vue?vue&type=style&index=0&id=3b9d04b7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__